import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {

  /**
   * Stocke le dernier etat mobile detecte.
   * BehaviorSubject permet aux nouveaux abonnes de recevoir immediatement
   * la valeur courante, utile lors de l'initialisation des vues.
   */
  private mobileSubject = new BehaviorSubject<boolean>(this.detectMobile());

  /**
   * Stocke l'information iPhone avec safe areas/notch.
   * Cette valeur sert aux ajustements CSS specifiques aux ecrans arrondis.
   */
  private isIphoneRoundedSubject = new BehaviorSubject<boolean>(this.detectIphoneRounded());

  /**
   * Flux public utilise par les composants pour reagir aux changements
   * de type de device sans acceder directement aux subjects internes.
   */
  public isMobile$ = this.mobileSubject.asObservable();

  /**
   * Flux public utilise pour appliquer ou retirer les styles lies aux
   * safe areas iPhone.
   */
  public isIphoneRounded$ = this.isIphoneRoundedSubject.asObservable();

  constructor(private zone: NgZone) {
    // Les changements de taille et d'orientation peuvent modifier le rendu
    // mobile. visualViewport couvre aussi les ajustements de viewport sur iOS.
    window.addEventListener('resize', () => this.refreshDeviceState());
    window.addEventListener('orientationchange', () => this.refreshDeviceState(true));
    window.visualViewport?.addEventListener('resize', () => this.refreshDeviceState(true));
  }

  /**
   * Retourne la valeur mobile courante de facon synchrone.
   * Utilise notamment pendant l'initialisation applicative avant abonnement.
   */
  public isMobile(): boolean {
    return this.mobileSubject.value;
  }

  /**
   * Retourne l'etat iPhone/safe area courant de facon synchrone.
   */
  public isIphoneRounded(): boolean {
    return this.isIphoneRoundedSubject.value;
  }

  /**
   * Recalcule et diffuse l'etat device dans la zone Angular afin que les vues
   * abonnees puissent declencher leur detection de changement.
   *
   * Le second passage differe laisse le navigateur stabiliser les dimensions
   * apres une rotation ou un resize du visualViewport.
   */
  private refreshDeviceState(delayed: boolean = false): void {
    this.zone.run(() => {
      this.mobileSubject.next(this.detectMobile());
      this.isIphoneRoundedSubject.next(this.detectIphoneRounded());
    });

    if (delayed) {
      window.setTimeout(() => this.refreshDeviceState(), 250);
    }
  }

  /**
   * Detecte un contexte mobile via le user-agent ou une largeur de viewport
   * compatible avec les interfaces mobiles.
   */
  private detectMobile(): boolean {
    const userAgent = navigator.userAgent.toLowerCase();

    return /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/.test(userAgent)
      || window.innerWidth <= 768;
  }

  /**
   * Detecte les iPhone modernes avec safe areas.
   * La detection combine le user-agent, le support CSS env() et une resolution
   * compatible avec les modeles a encoche ou ecran arrondi.
   */
    private detectIphoneRounded(): boolean {
    const userAgent = navigator.userAgent.toLowerCase();

 const isIphone = /iphone/.test(userAgent);

    if (!isIphone) {
      return false;
    }

    // Détection notch / écran arrondi
    const hasSafeArea =
      CSS.supports('padding-top: env(safe-area-inset-top)');

    // Résolutions iPhone modernes
    const modernIphone =
      window.screen.height >= 812 ||
      window.screen.width >= 375;
return hasSafeArea && modernIphone;
  }



}